"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
// A '.tsx' file enables JSX support in the TypeScript compiler,
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX
var React = require("react");
var ReactDOM = require("react-dom");
var $ = require("jquery");
var l = require("lenovo");
var lenovo_1 = require("lenovo");
var Lmd = lenovo_1.DTM.Lmd;
/*** Please keep the code clean and clear, whoever makes the code durty should refactor this***/
/*component translations*/
var translate = ["home search products|Search by product name (e.g. Moto Z), serial number, or IMEI",
    "capsfull search title|Search by name, serial number, IMEI, machine-type model, or nickname",
    "caps search|Search",
    "capssn search title short|Enter a serial number",
    "or|or",
    "no products found|unable to find any products that match the current query",
    "pn check failure message|The serial number (SN) is not eligible for this download",
    "please select your product|Please select your product"
];
translate = l.Translator.translateGroup(translate);
/*get current realm*/
var currentRealm = l.Common.getCurrentRealm();
var detailRealms = l.Common.getRealmsDetail();
/*get current customized datasource which is only for caps config,else search type is all*/
var currentDsType = lenovo_1.CapsSearchDatasourceType.Subseries;
/*data options*/
var bloodConfig = {
    initialize: true,
    local: [],
    queryTokenizer: function (data) {
        //remove (), because there is no result if search key word contains ()
        //Bloodhound.tokenizers.whitespace(data.replace(/[()]/g, "")).push(data.replace(/\s+/g, ""));
        return Bloodhound.tokenizers.whitespace(data.replace(/[()]/g, ""));
    },
    datumTokenizer: function (data) {
        if ($.isEmptyObject(data) || $.isEmptyObject(data["Name"])) {
            return [];
        }
        if (data["Brand"] === "MOTO") {
            if (data["Type"] === lenovo_1.ProductType.Group) {
                return [];
            }
        }
        else {
            var datatype = data["Type"];
            switch (currentDsType) {
                case lenovo_1.CapsSearchDatasourceType.Series:
                    if (datatype === lenovo_1.ProductType.Group)
                        return [];
                    break;
                case lenovo_1.CapsSearchDatasourceType.Subseries:
                    if (datatype === lenovo_1.ProductType.Group || datatype === lenovo_1.ProductType.Series)
                        return [];
                    break;
                case lenovo_1.CapsSearchDatasourceType.MT:
                    if (datatype === lenovo_1.ProductType.Group || datatype === lenovo_1.ProductType.Series || datatype === lenovo_1.ProductType.SubSeries)
                        return [];
                    break;
                case lenovo_1.CapsSearchDatasourceType.MTM:
                    if (datatype === lenovo_1.ProductType.Group || datatype === lenovo_1.ProductType.Series
                        || datatype === lenovo_1.ProductType.SubSeries || datatype === lenovo_1.ProductType.MachineType)
                        return [];
                    break;
                case lenovo_1.CapsSearchDatasourceType.PN:
                    if (datatype === lenovo_1.ProductType.Group || datatype === lenovo_1.ProductType.Series
                        || datatype === lenovo_1.ProductType.SubSeries || datatype === lenovo_1.ProductType.MachineType)
                        return [];
                    break;
                case lenovo_1.CapsSearchDatasourceType.Serial:
                    if (datatype !== lenovo_1.ProductType.Serial)
                        return [];
                    break;
            }
        }
        if (/unknown/i.test(data["Brand"])) {
            return [];
        }
        var tokens = data["Name"].replace(/[()]/g, "").split(/\s+/);
        var wholeWorldKey = tokens.join("");
        $.each(tokens, function (k, v) {
            var i = 0;
            while ((i + 1) < v.length) {
                tokens.push(v.substr(i, v.length));
                i++;
            }
        });
        var j = 0;
        var wholeWorldLength = wholeWorldKey.length;
        while ((j + 1) < wholeWorldLength) {
            tokens.push(wholeWorldKey.substr(j, wholeWorldLength));
            j++;
        }
        tokens.push(wholeWorldKey);
        return tokens;
    }
};
var engine = new Bloodhound(bloodConfig);
var keywordQueryAPI;
/*custom filter which filters suggestions for special business and adds brand name. core algorithm here*/
var filter = function (suggestions, element, searchKey) {
    searchKey = (searchKey.replace(/[()]/g, "") || "").toLowerCase();
    if (currentRealm === lenovo_1.RealmType.Moto) {
        return suggestions;
    }
    if (currentRealm === lenovo_1.RealmType.All && $(element).find(".dropdown-menu.home-search-option").length) {
        var filterCurrRealm = $(element).find(".dropdown-menu.home-search-option").attr("data-filter-realm");
        var brandsSelected_1 = detailRealms[filterCurrRealm].brands;
        suggestions = suggestions.filter(function (item) {
            return !item.Brand || brandsSelected_1.indexOf(item.Brand) > -1;
        });
    }
    var specialSeries = [
        "CCC3161D-9F83-4023-B8D2-4FC3A1CC864C",
        "89DBD35C-2320-452A-B36C-2B767E11E17C",
        "1ECCF386-4DA8-47BF-A4B0-ED844517230F",
        "080BE9AD-DB51-41F0-9274-DE96D59D9403",
        "4D8EF1F1-5B98-4705-8B72-667285D26820",
        "54F7A8ED-10EB-4CD3-A493-5AF5FF637096",
        "D8FC0B87-A453-46DE-9937-6B1C8B2587E6",
        "25E2DAF8-D3DF-4BD3-B545-FA4386C52D2C"
    ];
    var result = [];
    var counter = {};
    var brandGroup = {};
    suggestions.forEach(function (item, index) {
        var brand = item.Brand ? item.Brand : 'unknown';
        if (!brandGroup.hasOwnProperty(brand)) {
            brandGroup[brand] = [];
        }
        ;
        brandGroup[brand].push(item);
        if (!counter.hasOwnProperty(brand)) {
            counter[brand] = [0, 0];
        }
        if (item.Type === lenovo_1.ProductType.SubSeries) {
            counter[brand][0] = 1;
        }
        else if (item.Type === lenovo_1.ProductType.MachineType) {
            counter[brand][1] = 1;
        }
    });
    var tmp = [];
    var fullMatchLevel = new RegExp("\\/" + searchKey + "(?:\\/|$)", "i");
    var partialNameMatchLevel = new RegExp("" + searchKey, "i");
    var _loop_1 = function (p) {
        if (brandGroup.hasOwnProperty(p)) {
            if (p === "EBG") {
                tmp = $.grep(brandGroup[p], function (item) { return (!(counter[p][0] === 1 &&
                    counter[p][1] === 1 &&
                    specialSeries.indexOf(item["ParentID"]) >= 0)); });
                brandGroup[p] = tmp;
            }
            if (detailRealms[l.RealmType.Pcg].brands.indexOf(p) > -1) {
                var fullMatchTemp_1 = [], partialNameMatchTemp_1 = [], otherMatchTemp_1 = [];
                brandGroup[p].forEach(function (item) {
                    if (fullMatchLevel.test((item["Id"] || "").toLowerCase())) {
                        fullMatchTemp_1.push(item);
                    }
                    else if (partialNameMatchLevel.test((item["Name"] || "").toLowerCase())) {
                        if (counter[p][0] === 1) {
                            if (item["Type"] === lenovo_1.ProductType.SubSeries)
                                partialNameMatchTemp_1.push(item);
                        }
                        else if (item["Type"] === lenovo_1.ProductType.MachineType) {
                            partialNameMatchTemp_1.push(item);
                        }
                    }
                    else if (counter[p][0] === 1) {
                        if (item["Type"] === lenovo_1.ProductType.SubSeries)
                            otherMatchTemp_1.push(item);
                    }
                    else if (item["Type"] === lenovo_1.ProductType.MachineType) {
                        otherMatchTemp_1.push(item);
                    }
                });
                var fullMatchTempSorted = fullMatchTemp_1.sort(function (a, b) {
                    return a.Name.localeCompare(b.Name);
                });
                var partialNameTempSorted = partialNameMatchTemp_1.sort(function (a, b) {
                    return a.Name.localeCompare(b.Name);
                });
                var otherMatchTempSorted = otherMatchTemp_1.sort(function (a, b) {
                    return a.Name.localeCompare(b.Name);
                });
                brandGroup[p] = fullMatchTempSorted.concat(partialNameTempSorted, otherMatchTempSorted);
            }
        }
    };
    for (var p in brandGroup) {
        _loop_1(p);
    }
    for (var p in brandGroup) {
        if (brandGroup.hasOwnProperty(p)) {
            result.push({
                Name: p ? (p === "unknown" ? translate["please select your product"] : l.Translator.translate(p)) : "",
                Type: lenovo_1.ProductType.BrandGroup
            });
            result = result.concat(brandGroup[p]);
        }
    }
    return result;
};
/*cutom suggestion templates*/
var suggestionTemplate = function (data, searchType) {
    if (data.Type === lenovo_1.ProductType.BrandGroup) {
        return '<h4 class="group-name">' + data.Name + '</h4>';
    }
    if (searchType === lenovo_1.SearchComponentType.Home && currentRealm !== l.RealmType.Moto) {
        return "<div><div class=\"tt-image\"><img src='" + (data.Image ? data.Image : "https://download.lenovo.com/images/System/prodimage_default.jpg") + "'/></div><span>" + data.Name + "</span></div>";
    }
    else {
        return "<div>" + data.Name + "</div>";
    }
};
/*html render, different situations for home page and caps*/
var $element;
var allLocalProducts = [];
var SearchFilter = /** @class */ (function (_super) {
    __extends(SearchFilter, _super);
    function SearchFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isActive: false,
            selectedVal: props.value
        };
        _this.onOptSelect = _this.onOptSelect.bind(_this);
        return _this;
    }
    SearchFilter.prototype.onOptSelect = function (e) {
        var currDataRealm = $(e.currentTarget).attr("data-realm");
        if ($(this.refs.filterMenu).attr("data-filter-realm") !== currDataRealm) {
            this.setState({ selectedVal: Number(currDataRealm) });
        }
        //clear and rebulid index,otherwise it will show a wrong result when search SN with mutil MTs .eg 99C1821
        if (Number(currDataRealm) !== lenovo_1.RealmType.All) {
            engine.clear();
            engine.add(allLocalProducts);
        }
        this.props.onClicked(Number(currDataRealm));
    };
    SearchFilter.prototype.componentDidUpdate = function () {
        var $typeahead = $element.find("input.typeahead.tt-input");
        var keywords = $typeahead.typeahead('val');
        $typeahead.typeahead('val', "");
        $typeahead.focus().typeahead('val', keywords).focus();
    };
    SearchFilter.prototype.render = function () {
        var _this = this;
        var filterGroupClass = classNames({
            "btn-group": true,
            "home-search-select": true,
            "open": this.state.isActive === true
        });
        var filterBtnClass = classNames({
            "btn": true,
            "btn-default": true,
            "dropdown-toggle": true,
            "home-search-selected": true
        });
        var voidhref = "javascript:;";
        var filterText = this.props.options.length > 0 ? this.props.options[0].name : "";
        var optList = this.props.options.length > 0
            ? this.props.options.sort(function (a, b) {
                a["order"] = a.order || 0;
                b["order"] = b.order || 0;
                return a.order - b.order;
            }).map(function (opt, index) {
                var optObj = null;
                var iconMobile = "icon-mobile-dropdown icon-mse-" + (l.RealmType[opt.value] ? l.RealmType[opt.value].toLocaleLowerCase() : "");
                if (opt.value === _this.state.selectedVal) {
                    optObj = (React.createElement("li", null,
                        React.createElement("a", { href: voidhref, onClick: _this.onOptSelect, "data-brands": opt.brands.join(","), "data-realm": opt.value, selected: "selected" },
                            React.createElement("span", { className: iconMobile }),
                            opt.name)));
                    filterText = opt.name;
                }
                else {
                    optObj = (React.createElement("li", null,
                        React.createElement("a", { href: voidhref, onClick: _this.onOptSelect, "data-brands": opt.brands.join(","), "data-realm": opt.value },
                            React.createElement("span", { className: iconMobile }),
                            opt.name)));
                }
                return optObj;
            })
            : null;
        if (l.MobileDetectControl.mobileResource.mobile() && l.MobileDetectControl.mobileResource.tablet() == null) {
            filterText = "";
            var iconMobileselect = "icon-mse-" + (l.RealmType[this.state.selectedVal] ? l.RealmType[this.state.selectedVal].toLocaleLowerCase() : "");
            return (React.createElement("div", { className: filterGroupClass },
                React.createElement("button", { type: "button", className: filterBtnClass, "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
                    React.createElement("span", { className: iconMobileselect })),
                React.createElement("ul", { className: "dropdown-menu home-search-option", ref: "filterMenu", "data-filter-realm": this.state.selectedVal }, optList)));
        }
        else {
            return (React.createElement("div", { className: filterGroupClass },
                React.createElement("button", { type: "button", className: filterBtnClass, "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
                    filterText,
                    React.createElement("span", { className: "caret" })),
                React.createElement("ul", { className: "dropdown-menu home-search-option", ref: "filterMenu", "data-filter-realm": this.state.selectedVal }, optList)));
        }
    };
    SearchFilter.defaultProps = {
        options: [],
        value: 0,
        onClicked: function (currentFilterRealm) { }
    };
    return SearchFilter;
}(React.Component));
var searchFilterSource = function () {
    //get the realm with the brand of it
    var source = new Array();
    var replaceReg = /^.+\.(.+)/;
    var filterItemsText = {
        "all": "all products|All Products",
        "pcg": "pc products|PC Products",
        "dcg": "data center products|Data Center Products",
        "mbg": "mobile products|Mobile Products",
        "moto": "motorola products|Motorola Products",
        "smart": "smart products|Smart Products"
    };
    Object.keys(detailRealms).forEach(function (realmType, index) {
        var currRealm = detailRealms[realmType];
        var opt = {
            name: l.Translator.translate(currRealm.name.replace(replaceReg, function ($0, $1) {
                var filterText = filterItemsText[$1.toLowerCase()];
                return filterText ? filterText : $1.toLowerCase();
            })),
            value: Number(realmType),
            brands: currRealm.brands,
            order: currRealm.order
        };
        source.push(opt);
    });
    var sourceSorted = source.sort(function (a, b) { return a.order - b.order; });
    return sourceSorted;
};
var render = function (element, searchType, callback) {
    var globalSearch = function (element, isInclude) {
        if (isInclude === void 0) { isInclude = false; }
        var changePlaceholder = function (currentFilterRealm) {
            var $searchInput = $(element).find(".typeahead.form-control.tt-input");
            if ($searchInput.length > 0) {
                var placeholderText = "";
                var currRealm = l.RealmType[currentFilterRealm].toLocaleLowerCase();
                var textList = {
                    "all": "search placeholder|Search Support",
                    "pcg": "search pc support|Search PC Support",
                    "dcg": "search data center support|Search Data Center Support",
                    "mbg": "search mobile support|Search Mobile Support",
                    "moto": "search mobile support|Search Mobile Support",
                    "smart": "search smart support|Search Smart Support"
                };
                placeholderText = l.Translator.translate(textList[currRealm ? currRealm : "all"]);
                $searchInput.attr("placeholder", placeholderText);
            }
        };
        var filterProps = {
            options: searchFilterSource(),
            value: 0,
            onClicked: changePlaceholder
        };
        var filterComponent = React.createElement(SearchFilter, __assign({}, filterProps));
        var searchBoxComponent = React.createElement("div", { className: "home-search-input" },
            React.createElement("input", { className: "typeahead form-control", type: "text", placeholder: translate["search placeholder"] }),
            React.createElement("span", { className: "icon-search" }),
            React.createElement("br", null),
            React.createElement("img", { className: 'home-search-loading', src: '/msa/mse/images/loading.gif', alt: '' }));
        var result = isInclude
            ? React.createElement("div", null,
                filterComponent,
                searchBoxComponent)
            : searchBoxComponent;
        ReactDOM.render(result, element);
    };
    if (searchType === lenovo_1.SearchComponentType.Home) {
        globalSearch(element, currentRealm === lenovo_1.RealmType.All && searchType === lenovo_1.SearchComponentType.Home);
    }
    else if (searchType === lenovo_1.SearchComponentType.CapsFull) {
        ReactDOM.render(React.createElement("div", null,
            React.createElement("h3", { class: "caps-content-title-pc", t: "change product|Change Product" }),
            React.createElement("h4", { class: "caps-content-title left-title", t: "cscapsserialdescription|Enter your serial number to see available support options" }),
            React.createElement("div", { className: "caps-full-search" },
                React.createElement("input", { className: "typeahead", type: "text", placeholder: translate["capsfull search title"] }),
                React.createElement("button", { className: "icon-search" }))), element);
    }
    if (callback)
        callback();
};
function enableLoadingStyle() {
    $element.find('.home-search-loading').show();
    $('.home-search-input').children('.icon-search').addClass('icon-active');
    $('.caps-loading').show();
}
exports.enableLoadingStyle = enableLoadingStyle;
function disableLoadingStyle() {
    $element.find('.home-search-loading').hide();
    $('.home-search-input').children('.icon-search').removeClass('icon-active');
    $('.caps-loading').hide();
}
exports.disableLoadingStyle = disableLoadingStyle;
function judgeProductIdIsAodNumber(productId) {
    return !!productId &&
        typeof productId === 'string' &&
        l.Common.getCurrentRealm() === l.RealmType.Dcg &&
        productId.indexOf('-') > 2; // The `-` existed in string ,and the index of it is bigger than 2.
}
// for second search, it needs to get the remote data
function asyncSearch(keywords, linkTrackType, searchType) {
    if (!searchType) {
        searchType = lenovo_1.SearchComponentType.Home;
    }
    enableLoadingStyle();
    var keywordList = keywords.split(".");
    for (var j = 0; j < keywordList.length; j++) {
        if (j === 0) {
            keywords = judgeProductIdIsAodNumber(keywordList[j])
                ? keywordList[j]
                : keywordList[j].replace(/\-/g, "");
        }
        else
            keywords += "." + keywordList[j];
    }
    l.Content.queryByKeywordsAsync(keywords, function (data) {
        disableLoadingStyle();
        var $typeahead = $element.find("input.typeahead");
        l.DebugInfo.log("keywords search, get result : " + data);
        if (!$.isEmptyObject(data) && data instanceof Array) {
            data = data.filter(function (item) {
                if (item.isAccessory && item.Name)
                    return true;
                //MSE-1702
                if (/unknown/i.test(item.Brand))
                    return false;
                if (item.Id && !/\//i.test(item.Id))
                    return false;
                if (!item.Name && (typeof item.IsSupported === "undefined" || item.IsSupported))
                    return false;
                if ((!item.Serial || !item.Serial.replace(/\./g, "")) && item.IsSupported === false)
                    return false;
                if (currentRealm === lenovo_1.RealmType.All && searchType === lenovo_1.SearchComponentType.Home && $element.find(".dropdown-menu.home-search-option").length) {
                    var filterCurrRealm = $element.find(".dropdown-menu.home-search-option").attr("data-filter-realm");
                    var brandsSelected = detailRealms[filterCurrRealm].brands;
                    if (Number(filterCurrRealm) === lenovo_1.RealmType.Dcg || Number(filterCurrRealm) === lenovo_1.RealmType.All) {
                        //return mutil SN.MT
                        if (!item.Id && !item.Brand && !item.Serial && !item.ParentID && item.Type === l.ProductType.Serial)
                            return true;
                    }
                    //return product which has no SubSeries
                    if (typeof item.IsSupported !== "undefined" && !item.IsSupported && !item.Brand)
                        return true;
                    return brandsSelected.indexOf(item.Brand) > -1;
                }
                return true;
            });
        }
        if (!$.isEmptyObject(data) && data instanceof Array) {
            if (data.length === 1) { // one result
                if (data[0].isAccessory && data[0].id) {
                    window.location.href = "/accessorieslookup?partid=" + data[0].id;
                    return false;
                }
                else if (!data[0].Brand && (typeof data[0].IsSupported === "undefined" || data[0].IsSupported)) {
                    noResultFound(searchType);
                    l.DebugInfo.log("Product Brand is Null");
                    return;
                }
                else {
                    asyncSearchCallback(data, keywords, linkTrackType);
                }
            }
            else { // multi result    
                var isHaveAccessory_1 = false;
                var dataProcessed = data.map(function (item) {
                    if (item.isAccessory) {
                        isHaveAccessory_1 = true;
                        var itemTemp = __assign({}, item);
                        itemTemp.Name = item.Name + " (" + keywords + ")";
                        return itemTemp;
                    }
                    if (item.Name && item.Name.indexOf(keywords) === -1) {
                        var itemTempl = __assign({}, item);
                        itemTempl.Name = item.Name + " (" + keywords + ")";
                        return itemTempl;
                    }
                    return item;
                });
                engine.add(dataProcessed);
                $typeahead.typeahead('val', '');
                $typeahead.focus().typeahead('val', keywords).focus();
                // [ESDCG-440] support "no fuzzy search".
                var customConfig = l.LitePageLoader.getCapsCustomSettings($element.get(0));
                // if there are accessory ,we will clear the search data in engine.
                if (isHaveAccessory_1 || (customConfig && customConfig.cacheResult === false)) {
                    engine.clear();
                    engine.add(allLocalProducts);
                }
            }
        }
        else {
            noResultFound(searchType);
        }
    }, keywordQueryAPI);
}
;
function asyncSearchCallback(data, keywords, linkTrackType) {
    var callback = function () {
        if (window["LSB_Flag"]) {
            console.log("LSB_Flag:", window["LSB_Flag"]);
            window["LSB_Flag"] = false;
        }
        else {
            Lmd.setSearchEventRecord({
                searchType: data[0].Type,
                keyWordSearch: keywords
            });
        }
        var tabName = ($element.parents('#capsModal') && $element.parents('#capsModal').length) ? l.UrlUtility.getPSPTabs($element.parents('#capsModal').attr('tabname')) : "";
        var tabSubUrl = ($element.parents('#capsModal') && $element.parents('#capsModal').length) ? $element.parents('#capsModal').attr('subUrl') : "";
        if (currentRealm === lenovo_1.RealmType.Moto || (data[0].Brand && data[0].Brand.toUpperCase() === "MOTO")) {
            var productId = data[0].Id;
            var arr = productId.split('/');
            if (arr.length >= 4) {
                productId = arr[0] + "/" + arr[1] + "/" + arr[2];
            }
            if (typeof data[0].IsSupported === "undefined" || data[0].IsSupported) {
                window.location.href = l.UrlUtility.getFullPath("/products/" + productId) + "?Serial=" + data[0].Serial + "&linkTrack=" + linkTrackType;
            }
            else {
                window.location.href = l.UrlUtility.getFullPath("/basicwarrantylookup", true) + "?sn=" + data[0].Serial;
            }
        }
        else {
            var result = {
                id: data[0].Id,
                brand: data[0].Brand,
                serial: data[0].Serial,
                isSupported: data[0].IsSupported
            };
            var params = { "linkTrack": linkTrackType };
            if (tabName)
                params["tabName"] = tabName;
            if (tabSubUrl)
                params["subUrl"] = tabSubUrl;
            l.LitePageLoader.capsRun($element, result, $.extend({}, params));
        }
    };
    if (window["ConfirmCurrentProduct"] && !($("#showConfirmFlag").length > 0 && !Number($("#showConfirmFlag").text()))) {
        // confirm diag will show,if span #showConfirmFlag doesn't exists or it exists and flag is 1.
        window["ConfirmCurrentProduct"](data, callback, $element);
    }
    else {
        callback();
    }
}
function noPNResultFound() {
    var $ttmenu = $element.find(".tt-menu");
    var $ttdataset = $ttmenu.find('.tt-dataset').first();
    var addEmptyMsg = function (container) { container.append('<div class="empty message">' + translate['pn check failure message'] + '</div>'); };
    if ($ttdataset.length) {
        $ttdataset.empty();
        addEmptyMsg($ttdataset);
    }
    else {
        if ($ttmenu.children("div.empty").length === 0)
            addEmptyMsg($ttmenu);
    }
    $ttmenu.show();
}
var utf8_to_b64 = function (str) {
    return window.btoa(unescape(encodeURIComponent(str)));
};
function searchProductV2(keys, dataSource) {
    keys = keys.toLowerCase();
    var searchResult = dataSource.filter(function (row) {
        var flag = searchLikeProductV2(row, keys);
        return flag;
    });
    var searchResultSorted = searchResult.sort(sortFunc);
    return searchResultSorted;
}
;
var sortFunc = function (a, b) {
    var aPopularity = a.Popularity || 0;
    var bPopularity = b.Popularity || 0;
    if (aPopularity < bPopularity) {
        return 1;
    }
    else if (aPopularity > bPopularity) {
        return -1;
    }
    else {
        return (a.Name || "").localeCompare((b.Name || ""));
    }
};
var searchLikeProductV2 = function (row, key) {
    try {
        row.Popularity = 0;
        var name = row.Name ? row.Name.toLowerCase() : "";
        var result = false;
        if (name && key) {
            var keys = key.replace(/[()]/g, "").toLowerCase().split(" ");
            var tokens = name.replace(/[()]/g, "").split(/\s+/);
            var wholeWorldKey = tokens.join("").toLowerCase();
            for (var i = 0; i < keys.length; i++) {
                if (!keys[i]) {
                    continue;
                }
                var currentKeysIndex = wholeWorldKey.indexOf(keys[i]);
                if (currentKeysIndex >= 0) {
                    // @ts-ignore name max length less than 10000
                    row.Popularity += 10000 - currentKeysIndex + keys.length - i;
                }
            }
        }
        if (row.Popularity > 0) {
            result = true;
        }
        return result;
    }
    catch (e) {
        console.log("searchLikeProduct error:", e);
        return false;
    }
};
function CheckPNAtFirst(linkTrackType, searchType) {
    var keywords = $element.find(".typeahead.tt-input").val().trim();
    if (keywords !== '' && keywords.length > 1) {
        var url = l.UrlUtility.getFullServicesPath("drivers/checkpnisnormal");
        $("#mse_litepage_PNCheckCaps .tt-menu").css({ "display": "none" });
        $("#mse_litepage_PNCheckCaps .tt-menu").find("div").html("");
        var param = { "SerialNumber": keywords, "MachineType": "" };
        $.ajax({
            url: url,
            data: param,
            dataType: "json"
        }).done(function (pndata) {
            debugger;
            if (pndata.Status) {
                var pnCheckValue = keywords + "|" + "true";
                var pnCheckValue_base64 = utf8_to_b64(pnCheckValue);
                Cookies.set("PNIsNormal", pnCheckValue_base64, { path: "/" });
                var currentURL = window.location.href.toLowerCase();
                if (currentURL.indexOf('/products/') > -1) {
                    secondSearch(linkTrackType, searchType);
                }
                else {
                    window.location.href = currentURL;
                }
            }
            else {
                noPNResultFound();
                console.log("PNcheck isn't normal, it's value is " + keywords);
            }
        }).fail(function (err) {
            noPNResultFound();
            console.log("error:" + err);
        });
    }
    else {
        noPNResultFound();
        console.log("didn't get the keywords :" + keywords);
    }
}
function noResultFound(searchType) {
    var $ttmenu = $element.find(".tt-menu");
    var $ttdataset = $ttmenu.find('.tt-dataset').first();
    var addEmptyMsg = function (container) { container.append('<div class="empty message">' + translate['no products found'] + '</div>'); };
    if ($ttdataset.length) {
        $ttdataset.empty();
        addEmptyMsg($ttdataset);
    }
    else {
        if ($ttmenu.children("div.empty").length === 0)
            addEmptyMsg($ttmenu);
    }
    $ttmenu.show();
    if (searchType === lenovo_1.SearchComponentType.Home) {
        l.DTM.Lmd.pusherrorinfTrack("Product Search", "Product not found");
    }
    else {
        l.DTM.Lmd.pusherrorinfTrack("CAPs", "Product not found");
    }
}
// click search button or press enter to search again
function secondSearch(linkTrackType, searchType) {
    var keywords = $element.find(".typeahead.tt-input").val().trim();
    if (keywords !== '' && keywords.length > 1) {
        var ttselectable = $element.find(".tt-menu").find(".tt-selectable");
        if (ttselectable && ttselectable.length) {
            if (ttselectable.length === 1) {
                $(ttselectable[0]).trigger('click');
            }
            else {
                var ttcursor = $element.find(".tt-menu").find('.tt-dataset.tt-dataset-Products .tt-cursor');
                var i = ttselectable.index(ttcursor);
                if (i >= 0) {
                    $(ttselectable[i]).trigger('click');
                }
                else {
                    if (currentRealm === lenovo_1.RealmType.Moto)
                        $element.find(".typeahead.tt-input").focus().typeahead('val', $element.find(".typeahead.tt-input").val()).focus();
                    else
                        $(ttselectable[0]).trigger('click');
                }
            }
        }
        else {
            asyncSearch(keywords, linkTrackType, searchType);
        }
    }
}
exports.load = function (element, searchType, linkTrackType, callback, customKeywordQueryAPI) {
    if (linkTrackType === void 0) { linkTrackType = Lmd.dicLinkTrackType["Unknown"]; }
    keywordQueryAPI = customKeywordQueryAPI;
    if (searchType !== lenovo_1.SearchComponentType.Home) {
        currentDsType = l.LitePageLoader.getCapsSearchDsType(element);
    }
    l.Content.getAllProductsAsync(function (data) {
        $element = $(element);
        allLocalProducts = data;
        engine.add(data);
        render(element, searchType, callback);
        $element.find("input.typeahead").typeahead({
            hint: true,
            highlight: true,
            minLength: 1
        }, {
            source: function (query, sync, async) {
                if (query && query.length > 1) {
                    engine.search(query, function (suggestions) {
                        sync(filter(suggestions, element, query));
                    }, function (suggestions) {
                    });
                }
            },
            templates: {
                suggestion: function (data) { return suggestionTemplate(data, searchType); }
            },
            display: function (suggestion) { return suggestion.Name; },
            name: 'Products',
            limit: 999
        }).on({
            'typeahead:select': function (ev, suggestion) {
                if (!suggestion.isAccessory) {
                    var product;
                    var tabName = ($element.parents('#capsModal') && $element.parents('#capsModal').length) ? l.UrlUtility.getPSPTabs($element.parents('#capsModal').attr('tabname')) : "";
                    var tabSubUrl = ($element.parents('#capsModal') && $element.parents('#capsModal').length) ? $element.parents('#capsModal').attr('subUrl') : "";
                    if (suggestion.Id) {
                        product = {
                            id: suggestion.Id,
                            brand: suggestion.Brand
                        };
                        Lmd.setSearchEventRecord({
                            searchType: suggestion.Type,
                            keyWordSearch: $element.find(".typeahead.tt-input").val()
                        });
                        var params = { "linkTrack": linkTrackType };
                        if (tabName)
                            params["tabName"] = tabName;
                        if (tabSubUrl)
                            params["subUrl"] = tabSubUrl;
                        l.LitePageLoader.capsRun($element, product, $.extend({}, params));
                    }
                    else {
                        asyncSearch(suggestion.Name, linkTrackType, searchType);
                    }
                }
                else {
                    window.location.href = "/accessorieslookup?partid=" + suggestion.Id;
                }
            },
            'typeahead:render': function (ev, suggestion) {
                $(".tt-menu.tt-open h4").removeClass("tt-suggestion");
                $(".tt-menu.tt-open h4").removeClass("tt-selectable");
            },
            'keypress': function (e) {
                if (e.which === 13) {
                    debugger;
                    if (currentDsType == l.CapsSearchDatasourceType.PN) {
                        CheckPNAtFirst(linkTrackType, searchType);
                    }
                    else {
                        secondSearch(linkTrackType, searchType);
                    }
                }
            }
        });
        $element.find(".icon-search").on('click', function (e) {
            debugger;
            if (currentDsType == l.CapsSearchDatasourceType.PN) {
                CheckPNAtFirst(linkTrackType, searchType);
            }
            else {
                secondSearch(linkTrackType, searchType);
            }
        });
    });
};
